import type { ReactElement } from 'react';
import {
  DEFAULT_INTERVENTION_ICON,
  INTERVENTION_ICON_REGISTRY
} from '../../constants/interventionIconConstants';
import { InterventionIcon } from '../../api/generated';

interface InterventionIconProps {
  icon: InterventionIcon | undefined;
  className?: string;
  width?: number;
  height?: number;
}

export function InterventionIconComponent({
  icon,
  className,
  width,
  height
}: InterventionIconProps): ReactElement | null {
  if (!icon) return null;
  // Legacy data may hold an enum value that is no longer in the curated set
  // (e.g. OTHER/SPORTS/CREATIVITY). Fall back to the default glyph rather than
  // rendering nothing.
  const Comp = INTERVENTION_ICON_REGISTRY[icon] ?? INTERVENTION_ICON_REGISTRY[DEFAULT_INTERVENTION_ICON];
  if (!Comp) return null;
  // Spread width/height only when set so the SVG's intrinsic 16x16 isn't
  // clobbered by `width={undefined}` when callers size via CSS or rely on defaults.
  const sizeProps = {
    ...(width !== undefined && { width }),
    ...(height !== undefined && { height })
  };
  return <Comp className={className} {...sizeProps} />;
}
